var _style, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-upload_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-upload_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-upload_svg__st0",
    d: "M12 2.1c.4 0 .9.2 1.2.5l4.2 4.2c.4.4.4 1 0 1.4s-1 .4-1.4 0l-4-4-4 4c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4.2-4.2c.3-.3.8-.5 1.2-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-upload_svg__st0",
    d: "M12 6.4c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1s-1-.4-1-1v-10c0-.5.4-1 1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-upload_svg__st0",
    d: "M17 21.9H7c-.6 0-1-.4-1-1s.4-1 1-1h10c.6 0 1 .4 1 1s-.4 1-1 1z",
    opacity: 0.5
  })));
}

export default SvgIconUpload;